import Zoomable from 'react-inner-image-zoom';

import type { ImageType } from '@libs/common-types';
import { generateOptimizedPictureProps, type PictureSize } from '@libs/shared-ui';

const IMAGE_SIZES: PictureSize[] = [
    { width: 1400, height: 1400 },
    { width: 800, height: 800 },
    { width: 400, height: 400 },
];

type ImageSlideProps = Readonly<{
    item: ImageType;
    productName: string;
    index: number;
}>;

export const ImageSlide = ({ item, productName, index }: ImageSlideProps) => {
    const { imgSrc, pictureItems } = generateOptimizedPictureProps(item.url, IMAGE_SIZES);

    return (
        <Zoomable
            className="pdp-gallery__image"
            fadeDuration={0}
            hideHint
            zoomSrc={item.url}
            src={imgSrc}
            sources={pictureItems}
            zoomType="hover"
            imgAttributes={{
                loading: index === 0 ? 'eager' : 'lazy',
                alt: `${productName} - Image ${index + 1}`,
                fetchPriority: index === 0 ? 'high' : 'auto',
            }}
        />
    );
};
